// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2ZdBw","col":"styles_col__2xM9x","fulfillmentStatus":"styles_fulfillmentStatus__199B_","emailCol":"styles_emailCol__oe6Vq"};